var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 150"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "@keyframes opacity-ani{0%,to{opacity:.4}75%{opacity:1}}.bg_line_svg__polyline{fill:none;stroke:#8faeff;stroke-width:.2px;stroke-dasharray:.6px;opacity:.4;animation-name:opacity-ani;animation-duration:3s;animation-direction:alternate;animation-iteration-count:infinite;animation-timing-function:cubic-bezier(.55,.45,.45,.5)}"))), /*#__PURE__*/React.createElement("path", {
    className: "bg_line_svg__polyline",
    style: {
      animationDelay: "1s"
    },
    d: "M-4.32 52.53l40.15-23.52L-4.32 5.59M301.79 133.92L120.83 28.81-4.36 100.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg_line_svg__polyline",
    style: {
      animationDelay: "2s"
    },
    d: "M138.17-3.37l45.59 26.33-94.21 54.77 125.41 72.59 31.35-18.13 40.92 23.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg_line_svg__polyline",
    style: {
      animationDelay: "3s"
    },
    d: "M-4.36 155.97l98.61-57.29 98.53 57.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg_line_svg__polyline",
    style: {
      animationDelay: "4s"
    },
    d: "M304.82 80.84L185.16 9.11l33.3-19.29 47.23 27.46 39.6-22.95"
  }));
}

export default SvgBgLine;